import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { AudioLines, LogOut } from "lucide-react";

export default function Header({ variant = "default" }) {
    const { user, logout } = useAuth();
    const nav = useNavigate();

    return (
        <header className="glass-header sticky top-0 z-50 border-b border-slate-200/60" data-testid="site-header">
            <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
                <Link to="/" className="flex items-center gap-2 group" data-testid="logo-link">
                    <div className="w-8 h-8 rounded-lg bg-indigo-600 flex items-center justify-center transition-transform group-hover:rotate-3">
                        <AudioLines className="w-4 h-4 text-white" strokeWidth={2.5} />
                    </div>
                    <span className="text-lg font-semibold tracking-tight text-slate-900">Transcribely</span>
                </Link>

                <div className="flex items-center gap-3">
                    {user ? (
                        <>
                            {user.subscription_status === "pro" && (
                                <span className="hidden sm:inline-flex items-center gap-1 rounded-full bg-indigo-50 border border-indigo-100 px-2.5 py-0.5 text-xs font-medium text-indigo-700" data-testid="pro-badge">
                                    Pro
                                </span>
                            )}
                            <Link
                                to="/generate"
                                className="hidden md:inline-flex items-center px-3 py-1.5 text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors"
                                data-testid="nav-generate"
                            >
                                Generate
                            </Link>
                            <Link
                                to="/voices"
                                className="hidden md:inline-flex items-center px-3 py-1.5 text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors"
                                data-testid="nav-voices"
                            >
                                Voices
                            </Link>
                            <Link
                                to="/pricing"
                                className="hidden sm:inline-flex items-center px-3 py-1.5 text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors"
                                data-testid="nav-pricing"
                            >
                                Pricing
                            </Link>
                            <Link
                                to="/app"
                                className="hidden sm:inline-flex items-center px-3 py-1.5 text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors"
                                data-testid="nav-dashboard"
                            >
                                Dashboard
                            </Link>
                            <div className="flex items-center gap-2 pl-3 border-l border-slate-200">
                                {user.picture ? (
                                    <img src={user.picture} alt="" className="w-7 h-7 rounded-full" />
                                ) : (
                                    <div className="w-7 h-7 rounded-full bg-indigo-100 text-indigo-700 flex items-center justify-center text-xs font-semibold">
                                        {(user.name || user.email)[0].toUpperCase()}
                                    </div>
                                )}
                                <span className="hidden sm:inline text-sm text-slate-700">{user.name || user.email}</span>
                                <button
                                    onClick={() => { logout(); nav("/"); }}
                                    className="ml-1 p-1.5 text-slate-400 hover:text-slate-700 hover:bg-slate-100 rounded-md transition-colors"
                                    title="Sign out"
                                    data-testid="logout-btn"
                                >
                                    <LogOut className="w-4 h-4" strokeWidth={1.75} />
                                </button>
                            </div>
                        </>
                    ) : (
                        <>
                            <Link
                                to="/pricing"
                                className="hidden sm:inline-flex items-center px-3 py-1.5 text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors"
                                data-testid="nav-pricing-public"
                            >
                                Pricing
                            </Link>
                            <Link
                                to="/auth"
                                className="inline-flex items-center justify-center rounded-xl bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 transition-colors"
                                data-testid="signin-cta"
                            >
                                Sign in
                            </Link>
                        </>
                    )}
                </div>
            </div>
        </header>
    );
}
